import { useMutation, UseMutationResult } from 'react-query'
import request from '../../request'

export const useUpdateDealerVaultPartners = (): UseMutationResult<
  unknown,
  unknown,
  { data: Array<Record<string, unknown>> },
  unknown
> => {
  return useMutation(({ data }: { data: Array<Record<string, unknown>> }) =>
    request({
      url: `/admin/partners/dealervault`,
      method: 'POST',
      data,
    }),
  )
}
